import React from "react";
import classNames from "classnames";
import log from "cslog";
import { decodeStyle, parseStyle, mobile, tablet } from "../../../juntion";
import parse from "html-react-parser";
// import { getContent } from "../../../../dynamicdata/parser";
import { getContent, checkConditions } from "../../../junctionAbs";
// import { checkConditions } from "../../../../dynamicdata/utils";

const isString = (value) => {
    return typeof value === "string" || value instanceof String;
};

function Header({ id, db, dydb, device, gs, ctx }) {
    const data = db[id];

    //=========================
    const ps = parseStyle(data, gs, data.cstate);
    const fixStyle = decodeStyle(ps.fixStyle, gs);

    const style = decodeStyle(ps.style, gs);
    const styleTab = tablet(device) ? decodeStyle(ps.tablet, gs) : {};
    const styleMob = mobile(device) ? decodeStyle(ps.mobile, gs) : {};

    //=========================

    let input = ps.input;
    const content = getContent(dydb, input?.content);
    // let content = input?.content;
    // if (!isString(content)) {
    //     content = getContent(dydb, content);
    // }

    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    if (ps.classes.q_hide_on_mobile && mobile(device)) {
        return null;
    }

    if (!checkConditions(dydb, data.conditions)) {
        return null;
    }

    const all_style = {
        ...fixStyle,
        ...style,
        textAlign: input.textAlign,
        textTransform: input.uppercase ? "uppercase" : "none",
        ...(tablet(device) && styleTab),
        ...(mobile(device) && styleMob),
        fontSize:
            input.headingTag.type === "div" ? input.headingTag.value : "auto",
        letterSpacing: input.letterSpacing?.value || "normal",
        outline: "none",
    };

    const HeadingTag = ({ tagName, children, ...props }) => {
        return React.createElement(tagName, props, children);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <HeadingTag
                className={classNames(ps.classes)}
                disabled={false}
                tagName={input.headingTag.type}
                // className="qh1"
                style={all_style}
            >
                {parse(content)}
                {/* {DOMPurify.sanitize(content)} */}
            </HeadingTag>
        </div>
    );
}

export default Header;
